export interface PlanUpgradeRequiredDetails {
  feature?: string;
  required_plan?: string;
  upgrade_path?: string;
}

export interface PlanUpgradeRequiredPayload {
  code: string;
  message: string;
  details: PlanUpgradeRequiredDetails;
}

export function extractPlanUpgradeRequired(error: any): PlanUpgradeRequiredPayload | null {
  const structured = error?.response?.data?.error;
  if (structured?.code === 'authorization_plan_upgrade_required') {
    return {
      code: structured.code,
      message: structured.message || 'This feature requires a paid plan.',
      details: (structured.details || {}) as PlanUpgradeRequiredDetails,
    };
  }

  const legacyDetail = error?.response?.data?.detail;
  if (legacyDetail?.code === 'authorization_plan_upgrade_required') {
    return {
      code: legacyDetail.code,
      message: legacyDetail.message || 'This feature requires a paid plan.',
      details: (legacyDetail.details || {}) as PlanUpgradeRequiredDetails,
    };
  }

  return null;
}
